import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@restworld/utils-common';
import { useOrganizationsService } from '@restworld/data-services';

function useGetOrganizationPerformanceMetricsQuery({ enabled = true }: { enabled?: boolean } = {}) {
  const organisationsService = useOrganizationsService();

  const query = useQuery({
    queryKey: [QUERY_KEYS.ORGANISATIONS.PERFORMANCE_METRICS],
    queryFn: () => organisationsService.getOrganizationPerformanceMetrics(),
    select: (data) => data?.data,
    enabled,
  });

  return query;
}

export default useGetOrganizationPerformanceMetricsQuery;
